import styled from 'styled-components';

export const FlexOne = styled.div`
  flex: 1;
`;

export const SearchFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RequestRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 16px;
`;

export const RequestAccessWrapper = styled.div`
  padding: 24px 6px;
`;

export const ModalFooterActions = styled.div`
  display: flex;
  gap: 12px;
`;

export const ConfirmationList = styled.ul`
  margin: 16px 0;
  padding-left: 20px;
`;

// The terminal "Request submitted" modal is deliberately narrower than the
// confirm modal in the approved design. Storm's Modal is `width: fit-content`
// with no width or size prop, so the constraint has to live on the content:
// the design's text block is 389px wide (Figma node 1773:133563), which is what
// produces the 429px modal in 1773:133560. Without this the paragraphs run on
// until they hit the modal's `max-width: 80%` and the modal reads too wide.
// Storm's Modal is width: fit-content with only its own max-width: 80% as a
// bound, so modal bodies pin their own width to stop short content rendering a
// narrow dialog and long content rendering an over-wide one.
const MODAL_CONTENT_WIDTH = '389px';

export const RequestSubmittedBody = styled.div`
  max-width: ${MODAL_CONTENT_WIDTH};
`;

/*
  Body of the confirm state. Width is the caller's because the approved design
  gives each lane its own: the upgrade dialog is 536px and the combine-requests
  one 614px, so a shared value would be wrong for one of them. Callers that pass
  nothing keep Storm's `fit-content`, which is what shipped.
*/
export const ConfirmBody = styled.div<{ $width?: string }>`
  ${({ $width }) => ($width ? `width: ${$width};` : '')}
`;

/*
  Body of the confirmation modal while the submit request is running. The min
  height holds the modal at roughly the height of the confirm state it replaces,
  so the dialog does not collapse to the spinner and then jump back on failure.
*/
export const ModalLoadingBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 220px;
  width: ${MODAL_CONTENT_WIDTH};

  /*
    Storm's Heading carries block margins by default, which would push the label
    off the icon's centre line.
  */
  h2 {
    margin: 0;
  }
`;

export const AccountTypeGroupHeader = styled.div`
  display: flex;
  padding: 8px 20px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: #edeae3;
  font-size: 14px;
  font-weight: 700;
  color: #161d26;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PopoverContent = styled.div`
  display: inline-flex;
  max-width: 400px;
  padding: 20px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
`;

export const RequestAgreement = styled.div`
  margin: 8px 0 16px;
`;

export const RequestIntro = styled.div`
  margin-bottom: 24px;
`;

export const HelpTipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
